const mainHeader = document.getElementById('main-header');

const menuItems = document.querySelectorAll('.main-menu-item');
const menuButtons = document.querySelectorAll('.main-menu-item-button');
const submenus = document.querySelectorAll('.main-menu-submenu');

let activeSubmenu = null;
let isSubmenuOpen = false;

function initializeSubmenus() {
    menuButtons.forEach((button, index) => {
        const submenu = button.nextElementSibling;
        if (!submenu || !submenu.classList.contains('main-menu-submenu')) return;

        const submenuId = `submenu-${index}`;
        submenu.id = submenuId;
        button.setAttribute('aria-controls', submenuId);
        button.setAttribute('aria-pressed', 'false');
        button.setAttribute('aria-haspopup', 'true');
        submenu.setAttribute('aria-expanded', 'false');

        button.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            toggleSubmenu(button, submenu);
        });

        button.addEventListener('keydown', (e) => {
            handleKeyNavigation(e, button, submenu);
        });

        const closeButton = submenu.querySelector('.close-submenu-button');
        if (closeButton) {
            closeButton.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                hideSubmenu(button, submenu);
                button.focus(); // Return focus to the menu button
            });

            closeButton.addEventListener('keydown', (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    hideSubmenu(button, submenu);
                    button.focus(); // Return focus to the menu button
                }
            });
        }
    });

    document.addEventListener('click', (e) => {
        if (!e.target.closest('.main-menu-item') && isSubmenuOpen) {
            closeAllSubmenus();
        }
    });

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && isSubmenuOpen) {
            closeAllSubmenus();
        }
    });
}

function toggleSubmenu(button, submenu) {
    const isPressed = button.getAttribute('aria-pressed') === 'true';
    
    if (isPressed) {
        hideSubmenu(button, submenu);
    } else {
        // Close search modal if open (cross-module communication)
        if (window.isSearchModalOpen && window.isSearchModalOpen()) {
            window.hideSearchModal();
        }
        
        // Close any other open submenus first (but not this one)
        menuButtons.forEach((otherButton, index) => {
            const otherSubmenu = document.getElementById(`submenu-${index}`);
            if (otherSubmenu && otherSubmenu !== submenu && otherButton.getAttribute('aria-pressed') === 'true') {
                hideSubmenu(otherButton, otherSubmenu);
            }
        });
        
        showSubmenu(button, submenu);
        isSubmenuOpen = true;
        activeSubmenu = submenu;
    }
}

function showSubmenu(button, submenu) {
    button.setAttribute('aria-pressed', 'true');
    submenu.setAttribute('aria-expanded', 'true');
    submenu.classList.add('open');
    button.classList.add('active');
    
    // Focus management - move focus to first focusable element in submenu
    const firstFocusable = submenu.querySelector('a, button, [tabindex]:not([tabindex="-1"])');
    if (firstFocusable && isSubmenuOpen) {
        setTimeout(() => firstFocusable.focus(), 100);
    }
}

function hideSubmenu(button, submenu) {
    button.setAttribute('aria-pressed', 'false');
    submenu.setAttribute('aria-expanded', 'false');
    button.classList.remove('active');
    
    if (activeSubmenu === submenu) {
        activeSubmenu = null;
        isSubmenuOpen = false;
    }
    
    submenu.classList.add('closing');
    
    setTimeout(() => {
        submenu.classList.remove('open');
        submenu.classList.remove('closing');
    }, 400);
}

function closeAllSubmenus() {
    menuButtons.forEach((button, index) => {
        const submenu = document.getElementById(`submenu-${index}`);
        if (submenu) {
            hideSubmenu(button, submenu);
        }
    });
}

function handleKeyNavigation(e, button, submenu) {
    switch (e.key) {
        case 'Enter':
        case ' ': // Space key
            e.preventDefault();
            toggleSubmenu(button, submenu);
            break;
        case 'ArrowDown':
            if (button.getAttribute('aria-pressed') === 'true') {
                e.preventDefault();
                const firstLink = submenu.querySelector('a');
                if (firstLink) firstLink.focus();
            } else {
                showSubmenu(button, submenu);
                isSubmenuOpen = true;
                activeSubmenu = submenu;
            }
            break;
        case 'ArrowUp':
            if (button.getAttribute('aria-pressed') === 'true') {
                e.preventDefault();
                const links = submenu.querySelectorAll('a');
                if (links.length > 0) links[links.length - 1].focus();
            }
            break;
        case 'Escape':
            if (button.getAttribute('aria-pressed') === 'true') {
                e.preventDefault();
                hideSubmenu(button, submenu);
                button.focus(); // Return focus to button
            }
            break;
    }
}

window.onresize = closeAllSubmenus;

// Expose functions for cross-module communication
window.closeAllSubmenus = closeAllSubmenus;
window.isSubmenuOpen = () => isSubmenuOpen;

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeSubmenus);
} else {
    initializeSubmenus();
}